module.exports = __webpack_public_path__ + "img/payment_desktop_failed.8a94cd5c.svg";